import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <div className="hills" style={{ height: 300 }}>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/Hills.js